var path = '/_common/directives/ifastGrid/columnDirectives/htmlDropdown.tpl.html';
var html = "<span> <div id=dropdownCell ifast-drop-down-list data-ifast-object-id={{dropdownObjectId}} ifast-drop-down-object=dataItem.filters.redemptionOptionDropDown data-ifast-field-name={{fieldName}} data-ifast-selected-item=dropdownSelectedItem data-ifast-drop-down-options=dropdownOptions data-ifast-on-change=onChangeDropdown() class=gridDropDownCell></div> </span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/_common/directives/ifastGrid/columnDirectives/htmlDropdown.tpl.html
// module id = 775
// module chunks = 0 2